// export const BASE_API_URL = 'http://localhost/api/';
export const BASE_API_URL =
  process.env.REACT_APP_API_URL || "http://0.0.0.0/api";
// export const BASE_URL = 'http://localhost:3000';
export const BASE_URL =
  process.env.PUBLIC_URL || "https://dev-admin.civicpoints.io";
export const REACT_APP_ENV = process.env.REACT_APP_ENV || "dev";
export const TERMS_URL =
  process.env.REACT_APP_TERMS_URL || "https://civicpoints.io/terms-conditions";
//export const BASE_API_URL = 'http://192.168.0.200:8080/api/';
